'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, createContext, useCallback, useContext } from 'react';
import { useNotifications } from '@personly/libs-providers';
import { useStreams as useResource } from '@personly/libs-hooks';
type Unsubscribe = (handle: string) => void;
type Emit = (handle: string, event: string) => void;
type Subscribe = <T>(channel: string, event: string, cb: (response: T) => void) => Promise<string>;
type Context = {
  subscribe: Subscribe;
  unsubscribe: Unsubscribe;
  emit: Emit;
};
const StreamsContext = createContext<Context | null>(null);
interface Props {
  children: ReactNode;
  scope: string;
  url: string;
}
const StreamsProvider = t0 => {
  const $ = _c(7);
  const {
    children,
    scope,
    url
  } = t0;
  const {
    createNotification
  } = useNotifications();
  let t1;
  if ($[0] !== createNotification) {
    t1 = err => {
      const code = err ? decodeURIComponent(err) : "ERROR";
      createNotification("ERROR", code);
      console.error(err);
    };
    $[0] = createNotification;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onError = t1;
  let t2;
  if ($[2] !== createNotification) {
    t2 = (err_0, _setAccessToken) => {
      const code_0 = err_0 ? decodeURIComponent(err_0.message) : "ERROR";
      createNotification("ERROR", code_0);
      console.error(err_0);
    };
    $[2] = createNotification;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onConnectError = t2;
  const value = useResource("", onError, onConnectError, scope, url);
  let t3;
  if ($[4] !== children || $[5] !== value) {
    t3 = <StreamsContext.Provider value={value}>{children}</StreamsContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function useStreams() {
  const context = useContext(StreamsContext);
  if (!context) {
    throw new Error("useStreams requires a context!");
  }
  return context;
}
export { StreamsProvider, useStreams };